<template>
  <div>
    <VideoPlayAcademy v-if="!avaliacao" />
    <AvaliacaoAcademy v-else-if="avaliacao" />
  </div>
</template>

<script>
import { LIST_ALL_VIDEO_ACADEMY } from "@/store/actions/academy";
import VideoPlayAcademy from "./video-play/VideoPlayAcademy";
import AvaliacaoAcademy from "./avaliacao/AvaliacaoAcademy";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      executedOnce: false
    };
  },
  components: {
    VideoPlayAcademy,
    AvaliacaoAcademy
  },
  async created() {
    await this.$store.dispatch(LIST_ALL_VIDEO_ACADEMY);
  },
  computed: {
    ...mapGetters(["getVideosAcademy"]),
    avaliacao() {
      return this.$route.path.split("/").pop() === "test";
    },
    sections() {
      return this.getVideosAcademy || [];
    }
  },
  watch: {
    sections(newSections) {
      if (newSections.length && !this.executedOnce) {
        const section = newSections[0];
        this.$router.push(
          `/ead/section/${section?.idSection}/lesson/${section?.lessons[0]?.id}`
        );
        this.executedOnce = true;
      }
    }
  }
};
</script>
